import axios from 'axios'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { url } from './redirectUrl'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // timeout: 6000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    if (error.response.data.code === 100002) {
      notification.error({
        message: '登录过期',
        description: data.message
      })
      storage.clearAll()
      window.location.href = url
    }
    // 登录过期
    if (error.response.status === 401) {
      notification.error({
        message: '错误',
        description: data.message
      })
      storage.clearAll()
      window.location.href = url
    }
    if (error.response.status === 403) {
      notification.error({
        message: '没有权限',
        description: data.message
      })
    } else {
      notification.error({
        message: '错误',
        description: data.message
      })
    }
  }
  // return Promise.reject(error)
  return error.response.data
}

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['token'] = token
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
